import axios from 'axios';

export default {
    methods: {
        async fleteKmIndex(d, ok, err) {
            try {
                let r = await axios.get('flete/km?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteKmStore(d, ok, err) {
            try {
                let r = await axios.post('flete/km', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteKmUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('flete/km/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteKmShow(id, ok, err) {
            try {
                let r = await axios.get('flete/km/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteKmDestroy(id, ok, err) {
            try {
                let r = await axios.delete('flete/km/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteKmTotal(d, ok, err) {
            try {
                let r = await axios.post('flete/km/total', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/flete_km.js